"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rangeValidator = void 0;
const result_1 = __importDefault(require("../Utility/result"));
const statusType_1 = require("../Utility/statusType");
const validator_1 = __importDefault(require("../Utility/validator"));
class RangeValidator extends validator_1.default {
    validate(value, min, max) {
        const valueAsFloat = parseFloat(String(value));
        const minAsFloat = parseFloat(String(min));
        const maxAsFloat = parseFloat(String(max));
        const result = new result_1.default();
        if (isNaN(minAsFloat) && isNaN(maxAsFloat)) {
            result.setStatus(statusType_1.StatusType.OK);
            return result;
        }
        if (!isNaN(minAsFloat)) {
            if (valueAsFloat < minAsFloat) {
                result.setStatus(statusType_1.StatusType.FAILED);
                result.log(valueAsFloat + " is less than " + minAsFloat);
                return result;
            }
        }
        if (!isNaN(maxAsFloat)) {
            if (valueAsFloat > maxAsFloat) {
                result.setStatus(statusType_1.StatusType.FAILED);
                result.log(valueAsFloat + " is larger than " + maxAsFloat);
                return result;
            }
        }
        result.setStatus(statusType_1.StatusType.OK);
        return result;
    }
}
exports.rangeValidator = new RangeValidator();
